import vue from "vue";
import LoadingVue from "./Loading.vue";

declare interface loadingOptions {
    scale: number;
}

let loadingConstructor = vue.extend(LoadingVue);
let instance: LoadingVue, time: any;

export default class HfLoading {
    constructor(options: loadingOptions) {
        instance = new loadingConstructor({
            el: document.createElement("div"),
            data: options
        });
        document.body.appendChild(instance.$el);
    }
    load() {
        if (time) clearInterval(time);
        // @ts-ignore
        instance.visible = true;
        time = setInterval(() => {
            // @ts-ignore
            instance.deg += 100;
        }, 200);
    }
    close() {
        setTimeout(() => {
            clearInterval(time);
            // @ts-ignore
            instance.visible = false;
        }, 500);
    }
}
